import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function parseSizeToGB(str: string): number {
  const m = str.match(/([\d.]+)\s*(TB|GB)/i)
  if (!m) return 0
  const value = parseFloat(m[1])
  return m[2].toUpperCase() === "TB" ? value * 1024 : value
}
